{
  "version": 1,
  "asset_id": "601b9c23-0243-40f4-9c61-1de06c04d8ee",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/601b9c23-0243-40f4-9c61-1de06c04d8ee/offer-overlay-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/601b9c23-0243-40f4-9c61-1de06c04d8ee/offer-overlay-480.webp",
  "original_filename": "offer-overlay-480.webp",
  "size": 42790,
  "content_type": "image/webp",
  "created_at": "2026-10-04T23:37:17Z"
}
